import { TrimEditableImage } from './trim.editable-image';
import { TrimEditableImageManager } from '../editable-image/trim.editable-image.manager';
import { TrimFrameController } from './frame/trim.frame-controller';
import { TrimImageController } from './image/trim.image-controller';
import { TrimImageEvent } from './image/trim.image-event';
import { TrimTextController } from './text/trim.text-controller';
import { TrimDataManager } from '../data/trim-data.manager';
import { TrimCjContainer, TrimCjShape } from '../../model/cj-factory';
import { CJ_CONTAINER_NAME, CJ_DPOBJ_NAME } from '../../model/cj-factory/trim.cj-obj-name.collection';
import { TrimCjTool } from '../../../utilities/trim.cj-tool';
import * as lodash from 'lodash';
import { cloneDeep } from 'lodash';
import { TrimEditableEvent } from './trim.editable-event';
import { ListenerIdsType } from './image/trim.image-editable-tool';
import { TrimUiManager } from '../ui/trim.ui.manager';
import { TrimImageEditManager } from './trim.image-edit.manager';
import { TrimPrintManager } from '../../print/trim.print';
import { AdditionalShowType } from '../../../components/pages/layout/toolbar/layout.toolbar';
import { PrintTrimMenuType } from '../../../components/pages/sift/print-trim/hooks/use-print-trim';
import { store } from '../../../app/store';
import { dialogActions } from '../../../components/dialog/slice/dialog-slice';
import PixelConverter from '../../../utilities/pixel-converter';
import { CjTool } from '../../../utilities/cj-tool';
import { TrimPanZoomManager } from '../pan-zoom/trim.pan-zoom.manager';
import { SCREEN_COLOR_CODE } from '../../../layout-editor/manager/image-edit/image-edit.manager';

type CenterLineType = {
  lengthLine: TrimCjShape | null,
  sideLine: TrimCjShape | null,
}

type CursorType = {
  default: string,
  hover: string,
  move: string,
  text: string,
}

export class TrimEditableSideTool {
  private stage: TrimCjContainer;
  private readonly pageId: string;

  private imageEditManager!: TrimImageEditManager;
  private editableImageManager!: TrimEditableImageManager;
  private frameController!: TrimFrameController;
  private imageController!: TrimImageController;
  private imageEvent!: TrimImageEvent;
  private textController!: TrimTextController;
  private trimDataManager!: TrimDataManager;
  private editableEvent!: TrimEditableEvent;
  private printManager!: TrimPrintManager;
  private panZoomManager!: TrimPanZoomManager;

  private centerLines: CenterLineType[] = [];
  public cursors: CursorType = {
    default: '',
    hover: 'grab',
    move: 'grabbing',
    text: 'text',
  };
  private cursorListener: ListenerIdsType = {
    moveStart: undefined,
    moving: undefined,
    moveEnd: undefined,
  };

  private additionalShowType: AdditionalShowType = 'show';
  // mode: 'pan-zoom' | 'select' = 'pan-zoom';

  public dragPointX: number = 0;
  public dragPointY: number = 0;
  public isCenterLine: boolean = false;

  constructor(stage: TrimCjContainer, pageId: string) {
    this.stage = stage;
    // this.fbCanvas = fbCanvas;
    this.pageId = pageId;
  }

  di(
    imageEditMng: TrimImageEditManager,
    frameController: TrimFrameController,
    imageController: TrimImageController,
    editableMng: TrimEditableImageManager,
    imageEvent: TrimImageEvent,
    textController: TrimTextController,
    layoutDataManager: TrimDataManager,
    editableEvent: TrimEditableEvent,
    albumMng: TrimPrintManager,
    panZoomMng: TrimPanZoomManager,
  ): void {
    this.imageEditManager = imageEditMng;
    this.frameController = frameController;
    this.imageController = imageController;
    this.editableImageManager = editableMng;
    this.imageEvent = imageEvent;
    this.textController = textController;
    this.trimDataManager = layoutDataManager;
    this.editableEvent = editableEvent;
    this.printManager = albumMng;
    this.panZoomManager = panZoomMng;
  }

  initialize(): void {
  }

  destroy(): void {
    this.centerLines = [];
    this.dragPointX = 0;
    this.dragPointY = 0;
  }

  update(stage: TrimCjContainer): void {
    this.stage = stage;
  }

  // - canvas 操作用ロック -
  lock() {
    if (!this.stage) return;
    this.imageEvent.isSelect = false;
  }

  unlock() {
    if (!this.stage) return;
    this.imageEvent.isSelect = true;
    // document.body.style.cursor = this.cursors.default;
  }

  // - 中心線の追加 -
  addCenterLine() {
    const imageArea = this.trimDataManager.getImageArea();
    this.isCenterLine = true;
    const line = TrimCjTool.getCenterLine(imageArea);
    line.alpha = 1;
  }

  // 中心線解除
  removeCenterLine() {
    const imageArea = this.trimDataManager.getImageArea();
    this.isCenterLine = false;
    const line = TrimCjTool.getCenterLine(imageArea);
    line.alpha = 0;
  }

  // - PNG画像追加 -
  async addImage(editableImage: TrimEditableImage, isRestore?: boolean) {
    return new Promise<void>((resolve) => {
      // PNG画像生成
      const newImage = new TrimCjContainer(this.pageId);
      const pngImage = lodash.cloneDeep(editableImage.editable);
      const ratio = (Number(editableImage.virtualWidth) ?? 1) / (this.imageEditManager.templateVirtual.w ?? 1) * 5;

      pngImage.scaleX = 1 / ratio;
      pngImage.scaleY = 1 / ratio;
      const pngData = cloneDeep(pngImage.getTransformedBounds());
      newImage.originalBounds.width = pngData.width;
      newImage.originalBounds.height = pngData.height;
      let realPath;
      let virtualPath;
      if (isRestore) {
        realPath = editableImage.original?.name ?? editableImage.name;
        virtualPath = editableImage.name;
      } else {
        realPath = editableImage.name;
        virtualPath = editableImage.path;
      }

      newImage.editableImageId = editableImage.id;
      newImage.realPath = realPath;
      newImage.virtualPath = virtualPath;
      newImage.fileName = editableImage.name;
      newImage.addChild(pngImage);
      TrimCjTool.checkLoad(newImage)
        .then((v) => {
          const pos = {
            width: this.imageEditManager.templateVirtual.w,
            height: this.imageEditManager.templateVirtual.h,
          };
          const pngData = v.getTransformedBounds();

          pngImage.set({
            x: pos.width / 2,
            y: pos.height / 2,
            name: CJ_DPOBJ_NAME.freeGraphic,
          });
          v.set({
            x: pos.width / 2,
            y: pos.height / 2,
            regX: pos.width / 2 + pngData.width / 2,
            regY: pos.height / 2 + pngData.height / 2,
            name: CJ_CONTAINER_NAME.image,
            pageId: this.pageId,
            real: {
              x: pos.width / 2,
              y: pos.height / 2,
              width: pngData.width * ratio,
              height: pngData.height * ratio,
            },
            virtual: {
              x: pos.width / 2,
              y: pos.height / 2,
              width: pngData.width,
              height: pngData.height,
            },
            differPos: {
              x: 0,
              y: 0,
            },
            defaultPos: {
              x: pos.width / 2,
              y: pos.height / 2,
            },
            scaleX: 1,
            scaleY: 1,
            rotation: 0,
          });

          v.originalBounds.x = cloneDeep(v.x);
          v.originalBounds.y = cloneDeep(v.y);

          if (isRestore) {
            const printTrimData = this.printManager.printTrimData;
            const stamps = printTrimData?.view.stamps ?? [];
            const stamp = stamps.find(stamp => stamp.fileName === editableImage.name);
            if (stamp) {
              v.set({
                x: stamp.pos.x,
                y: stamp.pos.y,
                rotation: stamp.rotate,
                scaleX: stamp.scale,
                scaleY: stamp.scale,
              });
              v.movePos = {
                x: (stamp.pos.x - v.virtual.x + v.differPos.x),
                y: (stamp.pos.y - v.virtual.y + v.differPos.y),
              };
            }
          }
          // 透過PNG対策として設置
          const hitArea = new TrimCjShape();
          hitArea.graphics.f('#fff').dr(v.getBounds().x, v.getBounds().y, v.getBounds().width, v.getBounds().height);
          hitArea.alpha = 0.01;
          newImage.addChild(hitArea);
          this.imageEvent.setImageEvent(newImage, 'image', 'png');
          this.stage.addChild(newImage);
          this.trimDataManager.setFreeGraphic(newImage);
          console.log('img==========', newImage);
          this.editableEvent.action(
            'addPNG',
            `PNG画像(id: ${newImage.editableImageId})を追加。`,
            () => {
              this.stage.addChild(newImage);
              // this.editableImageManager.toUse(newImage.editableImageId ?? '');
            },
            () => {
              this.stage.removeChild(newImage);
              this.trimDataManager.removeFreeGraphic(newImage.editableImageId ?? '');
              // this.editableImageManager.toUnUse(newImage.editableImageId ?? '');
            },
          );
          isRestore || TrimUiManager.ins.emit('t->r:wait-loading', { message: '' })
          resolve();
        });
    });
  }

  // - 使用中の画像を一時保存する -
  private async recordImage(prevEditors: TrimCjContainer[], prevImages: TrimEditableImage[]) {
    for (const prevEditor of prevEditors) {
      const photo = TrimCjTool.getPhotoContainer(prevEditor);
      const prevImg = TrimCjTool.getImageContainer(prevEditor);
      if (TrimCjTool.checkPhotoInFrame(prevEditor)) {
        const img = this.editableImageManager.list.find((img) => img.flags.used && img.id === photo.editableImageId);
        img && prevImages.push(img);
        try {
          this.editableImageManager.toUnUse(prevImg.editableImageId ?? '');
        } catch {
        }
      }
    }
  }

  // - 中枠の回転 -
  async rotateAdditional() {
    try {
      await this.printManager.rotateTemp();
    } catch (e) {
      console.error(e);
      store.dispatch(dialogActions.pushMessage({
        title: '確認',
        message: ['テンプレートの取得に失敗しました'],
        buttons: [{label: 'OK', callback: () => store.dispatch(dialogActions.pop())}]
      }))
      return;
    }
    const bgImage = TrimCjTool.getBgImage(this.stage);
    const edge = TrimCjTool.getEdge(this.stage);
    const stageMask = TrimCjTool.getStageMask(this.stage);
    const dateText = TrimCjTool.getDateTextContainer(this.stage);
    const guide = TrimCjTool.getGuidContainer(this.stage);
    const editor = this.trimDataManager.getEditor();
    bgImage && this.stage.removeChild(bgImage);
    edge && this.stage.removeChild(edge);
    stageMask && this.stage.removeChild(stageMask);
    dateText && this.stage.removeChild(dateText);
    guide && this.stage.removeChild(guide);
    this.stage.removeChild(editor);
    this.stage.stage.update();
    this.imageEditManager.resizeStage();
    this.stage.x = TrimImageEditManager.STAGE_CONTAINER_X;
    this.stage.y = TrimImageEditManager.STAGE_CONTAINER_Y;
    this.frameController.createEdge();
    this.frameController.createBgImage();
    await this.frameController.createPhotoArea();
    await this.textController.createDateText();
    this.frameController.createGuide();
    await this.frameController.createStageMask(SCREEN_COLOR_CODE[this.imageEditManager.printMenu.screenColor]);
    this.editableEvent.sortContainer();
    this.stage.stage.update();
    this.panZoomManager.reBoot()
    TrimUiManager.ins.emit('r->t:zoom:fit', {});

    // const rotateTempData = this.albumManager.currentPrint?.parseData.templateData.exTemplate[0].rotExchange[0];
    // const rotateTempList = [
    //   rotateTempData.rot000[0].$,
    //   rotateTempData.rot090[0].$,
    //   rotateTempData.rot180[0].$,
    //   rotateTempData.rot270[0].$,
    // ];

    // const activeTemp = rotateTempList.filter((v) => v.enable === '1');
    // if (!activeTemp.length) return;
    // const prevEditors = this.layoutDataManager.selector('getEditors', this.pageId);
    // const prevImages: TrimEditableImage[] = [];
    // await this.recordImage(prevEditors, prevImages);
    // const acquiredTemplateList: any[] = (this.albumManager.currentPrint?.additionalParseData ?? []);
    // const nowTemp = acquiredTemplateList.find(temp => temp.thumbnail === this.albumManager.currentPrint?.thumbnail.templatePath);
    // const targetTemp = activeTemp.find(temp => `${this.imageEditManager.getBaseUrl}/${temp.path}/thumbnail.jpg` === this.albumManager.currentPrint?.thumbnail.templatePath);
    // if (acquiredTemplateList.length > 1 && nowTemp) {
    //   const i = activeTemp.indexOf(targetTemp);
    //   const j = i + 1 > activeTemp.length - 1 ? 0 : i + 1;
    //   const nextTempPath = activeTemp[j].path;
    //   await this.layoutDataManager.dispatch('changeTemp', this.pageId);
    //   const nextTemp = acquiredTemplateList.find(temp => temp.thumbnail === `${this.imageEditManager.getBaseUrl}/${nextTempPath}/thumbnail.jpg`);
    //   if (!nextTemp || nextTemp === nowTemp) return;
    //   TrimUiManager.ins.emit('t->r:wait-loading', { message: 'テンプレートを読み込んでいます...' });
    //   await this.imageEditManager.updateTemplate(nextTemp, prevImages, initData);
    //   TrimUiManager.ins.emit('t->r:wait-loading', { message: '' });
    // }
  }

  // - 中枠の形状変更 -
  async transformAdditional() {
    // const shapeTemp = this.albumManager.currentPrint?.parseData.templateData.exTemplate[0].shapeExchange[0].$;
    // if (shapeTemp.enable === '0') return;
    // const initData: PrintPageInitType = {
    //   modeAbleArea: 'on',
    //   modeInOut: this.imageController.imageSetMode,
    //   display: this.isCenterLine,
    //   fitNum: this.imageController.fitNum,
    //   additionalShow: this.additionalShowType,
    //   modeCursor: 'select',
    // };
    // const prevEditors = this.layoutDataManager.selector('getEditors', this.pageId);
    // const prevImages: TrimEditableImage[] = [];
    // await this.recordImage(prevEditors, prevImages);
    // const acquiredTemplateList: any[] = (this.albumManager.currentPrint?.additionalParseData ?? []);
    // const nowTemp = acquiredTemplateList.find(temp => temp.thumbnail === this.albumManager.currentPrint?.thumbnail.templatePath);
    // if (acquiredTemplateList.length > 1 && nowTemp) {
    //   this.stage.removeAllChildren();
    //   await this.layoutDataManager.dispatch('changeTemp', this.pageId);
    //   const nextTemp = acquiredTemplateList.find(temp => temp.thumbnail === `${this.imageEditManager.getBaseUrl}/${shapeTemp.path}/thumbnail.jpg`);
    //   if (!nextTemp) return;
    //   TrimUiManager.ins.emit('t->r:wait-loading', { message: 'テンプレートを読み込んでいます...' });
    //   await this.imageEditManager.updateTemplate(nextTemp, prevImages, initData);
    //   TrimUiManager.ins.emit('t->r:wait-loading', { message: '' });
    // }
  }

  // - 中枠の表示（表示→半透明→非表示のループ） -
  transparentAdditional(type: AdditionalShowType, callback: () => void) {
    // const additional = this.layoutDataManager.selector('getAdditional', this.pageId);
    // if (!this.imageEditManager.isDAI || !additional) {
    //   callback();
    //   return;
    // }
    // ;
    // this.additionalShowType = type;
    // switch (type) {
    //   case 'semi':
    //     additional.alpha = 0.5;
    //     break;
    //   case 'hide':
    //     additional.alpha = 0;
    //     break;
    //   case 'show':
    //     additional.alpha = 1;
    //     break;
    //   default:
    //     break;
    // }
    // this.stage.stage.update();
    callback();
  }
}
